class CustomStickyEle extends HTMLElement {
  constructor() {
    super();

    if (!this.scopeFrom) {
      return;
    }

    const intersectionObserver = new IntersectionObserver(
      this.handleIntersection.bind(this)
    );
    intersectionObserver.observe(this.scopeFrom);
  }

  get scopeFrom() {
    return document.querySelector(`.${this.getAttribute('data-scopeFrom')}`);
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.target === this.scopeFrom) {
        this.scopeFromPassed =
          entry.boundingClientRect.bottom <= 0 ||
          entry.boundingClientRect.top > window.innerHeight;
      }
    });
    
    // 这里最优解是在动画开始前display:block;
    // 动画结束后display:none;
    // 后续使用gsap的时候可以实现, motion不好实现,
    // 于是就使用了visibility:hidden;因为这个属性不会响应事件.
    // 以及使用了gsap修改display之后就要在外部处理是否渲染了,
    // 因为此时样式的display属性无法层叠掉行内设置的display属性了,
    // 利用visibility:hidden;不响应事件是一个取巧的做法
    if (this.scopeFromPassed) {
      Motion.animate(
        this,
        {
          opacity: 1,
          visibility: "visible",
          transform: ["translateY(15px)", "translateY(0)"],
        },
        { duration: 1, easing: [0.16, 1, 0.3, 1] }
      );
    } else {
      Motion.animate(
        this,
        {
          opacity: 0,
          visibility: "hidden",
          transform: ["translateY(0)", "translateY(15px)"],
        },
        { duration: 1, easing: [0.16, 1, 0.3, 1] }
      );
    }
  }
}

customElements.define("custom-sticky-ele", CustomStickyEle);
